<template>
  <section id="card-text-alignment">
    <b-overlay :show="isLoading" rounded="sm">
      <b-row>
        <b-col>
          <b-button
              variant="gradient-primary"
              :to="{ name: 'pedidos'}"
          >
            <feather-icon
                icon="ArrowLeftIcon"
                class="mr-50"
            />
            <span class="align-middle">Voltar</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="position-static mt-2 mb-2">
            <div class="stepper-wrapper">
              <div
                v-for="(step, index) in stepsFlow"
                :key="index"
                :class="['stepper-item', getStepClass(index)]"
              >
                <div class="step-counter">
                  <feather-icon
                    :color="getStepIconColor(index)"
                    size="18"
                    :icon="step.icon"
                  />
                </div>
                <div class="step-name">{{ step.name }}</div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card
              title="Pedido"
              class="position-static mt-2 mb-2"
          >
           <pedido/>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card
              title="Itens do Pedido"
              class="position-static mt-2 mb-2"
          >
            <ItensPedido/>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card
              title="Total do Pedido"
              class="position-static mt-2 mb-2"
          >
            <total-pedido/>
          </b-card>
        </b-col>
      </b-row>

      <template #overlay>
        <div class="text-center">
          <b-spinner variant="primary" label="Carregando..."></b-spinner>
          <p class="mt-2 mb-0">Carregando detalhes do pedido...</p>
        </div>
      </template>
    </b-overlay>
  </section>
</template>
<script>
import { BFormSelect, BSpinner, BOverlay } from 'bootstrap-vue';

import ItensPedido from '@/views/app/PTC/Pedidos/cardsDetalhePedido/ItensPedido.vue';
import TotalPedido from '@/views/app/PTC/Pedidos/cardsDetalhePedido/totalPedido.vue';
import Pedido from '@/views/app/PTC/Pedidos/cardsDetalhePedido/pedido.vue';
import PTC_PedidosService from '@/services/PTC/PTC_Pedidos.service';

const ptc_pedidosService = new PTC_PedidosService();

export default {
  components: {
    Pedido,
    TotalPedido,
    ItensPedido,
    BFormSelect,
    BSpinner,
    BOverlay,
  },
  data() {
    return {
      isLoading: false,
      currentStep: 0,
      pedidoSituacao: '',
      stepDefinitions: {
        'Em Cotação': { order: 1, icon: 'PercentIcon', name: 'Em Cotação' },
        'Em Implantação': { order: 2, icon: 'RefreshCcwIcon', name: 'Em Implantação' },
        Enviado: { order: 3, icon: 'SendIcon', name: 'Enviado' },
        'Em Aprovação': { order: 4, icon: 'ThumbsUpIcon', name: 'Em Aprovação' },
        Cancelado: {
          order: 5, icon: 'XIcon', name: 'Cancelado', isFinal: true, isError: true,
        },
        Implantado: { order: 6, icon: 'CheckCircleIcon', name: 'Implantado' },
        Integrado: { order: 7, icon: 'LinkIcon', name: 'Integrado' },
        'A Faturar': { order: 8, icon: 'FileTextIcon', name: 'A Faturar' },
        'Faturado Parcial': { order: 9, icon: 'DollarSignIcon', name: 'Faturado Parcial' },
        'Faturado Total': {
          order: 10, icon: 'CheckIcon', name: 'Faturado Total', isFinal: true,
        },
      },
    };
  },

  methods: {
    getStepClass(stepIndex) {
      const classes = [];

      if (stepIndex < this.currentStep) {
        classes.push('completed');
      } else if (stepIndex === this.currentStep) {
        classes.push('active');
        const currentStepData = this.stepsFlow[stepIndex];
        if (currentStepData && this.stepDefinitions[currentStepData.originalName]?.isError) {
          classes.push('error');
        }
      }

      return classes.join(' ');
    },

    getStepIconColor(stepIndex) {
      if (stepIndex < this.currentStep) {
        return 'white';
      } if (stepIndex === this.currentStep) {
        const currentStepData = this.stepsFlow[stepIndex];
        if (currentStepData && this.stepDefinitions[currentStepData.originalName]?.isError) {
          return 'white';
        }
        return 'white';
      }
      return 'grey';
    },

    buildStepsFlow() {
      if (!this.pedidoSituacao) return [];

      const currentStepData = this.stepDefinitions[this.pedidoSituacao];
      if (!currentStepData) return [];

      if (currentStepData.isError) {
        const steps = [];
        for (const [situacao, data] of Object.entries(this.stepDefinitions)) {
          if (data.order <= currentStepData.order && !data.isError) {
            steps.push({
              name: data.name,
              icon: data.icon,
              originalName: situacao,
              order: data.order,
            });
          }
        }
        steps.push({
          name: currentStepData.name,
          icon: currentStepData.icon,
          originalName: this.pedidoSituacao,
          order: currentStepData.order,
        });

        return steps.sort((a, b) => a.order - b.order);
      }

      const steps = [];
      const maxOrder = Math.max(...Object.values(this.stepDefinitions)
        .filter((step) => !step.isError)
        .map((step) => step.order));

      for (const [situacao, data] of Object.entries(this.stepDefinitions)) {
        if (!data.isError && data.order <= maxOrder) {
          steps.push({
            name: data.name,
            icon: data.icon,
            originalName: situacao,
            order: data.order,
          });
        }
      }

      return steps.sort((a, b) => a.order - b.order);
    },

    updateCurrentStep() {
      if (!this.pedidoSituacao) return;

      const currentStepData = this.stepDefinitions[this.pedidoSituacao];
      if (!currentStepData) return;

      const stepIndex = this.stepsFlow.findIndex((step) => step.originalName === this.pedidoSituacao);
      this.currentStep = stepIndex >= 0 ? stepIndex : 0;
    },

    async getPedido() {
      this.isLoading = true;
      try {
        const response = await ptc_pedidosService.retornaPedidoDetalhe(this.$route.params.id);
        if (response && response.pedido && response.pedido.length > 0) {
          this.pedidoSituacao = response.pedido[0].pedidoSituacao;
          this.updateCurrentStep();
        }
      } catch (error) {
        console.error('Erro ao buscar pedido:', error);
        this.$toast({
          component: 'ToastificationContent',
          props: {
            title: 'Erro',
            text: 'Erro ao carregar os detalhes do pedido. Tente novamente.',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
  },

  computed: {
    stepsFlow() {
      return this.buildStepsFlow();
    },
  },

  mounted() {
    this.getPedido();
  },
};
</script>

<style scoped lang="scss">
.stepper-wrapper {
  font-family: Arial;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 22px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.active .step-counter {
  background-color: #007bff;
}

.stepper-item.completed .step-counter {
  background-color: #42cd81;
}

.stepper-item.error .step-counter {
  background-color: #dc3545;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 4px solid #42cd81;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}
</style>
